import { FilterChip, SegmentedFilter, Select } from "@amber/ui";
import type { SearchPageSearch } from "./params";

const LANGUAGE_OPTIONS = [
  { value: "all", label: "All" },
  { value: "en", label: "English" },
  { value: "de", label: "German" },
  { value: "other", label: "Other" },
] as const;
const READINESS_OPTIONS = [
  { value: "all", label: "All" },
  { value: "eligible", label: "Eligible" },
  { value: "draft", label: "Draft" },
] as const;
const CORRECTED_OPTIONS = [
  { value: "all", label: "All" },
  { value: "yes", label: "Corrected" },
  { value: "no", label: "Not corrected" },
] as const;

export function SearchFilters({
  search,
  set,
  profiles,
  personName,
}: {
  search: SearchPageSearch;
  set: (patch: SearchPageSearch) => void;
  profiles: readonly { id: string; name: string }[] | undefined;
  personName: string | undefined;
}) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2">
      <span className="text-md text-muted">Transcripts:</span>
      <SegmentedFilter
        label="Language"
        value={search.language ?? "all"}
        options={LANGUAGE_OPTIONS}
        onChange={(v) => {
          set({ language: v === "all" ? undefined : v });
        }}
      />
      <SegmentedFilter
        label="Readiness"
        value={search.readiness ?? "all"}
        options={READINESS_OPTIONS}
        onChange={(v) => {
          set({ readiness: v === "all" ? undefined : v });
        }}
      />
      <SegmentedFilter
        label="Corrections"
        value={search.corrected ?? "all"}
        options={CORRECTED_OPTIONS}
        onChange={(v) => {
          set({ corrected: v === "all" ? undefined : v });
        }}
      />
      <div className="w-[180px]">
        <Select
          aria-label="Person"
          value={search.person ?? ""}
          onChange={(e) => {
            set({ person: e.target.value || undefined });
          }}
        >
          <option value="">Any person</option>
          {profiles?.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </Select>
      </div>
      {personName ? (
        <FilterChip
          label="Person"
          value={personName}
          onRemove={() => {
            set({ person: undefined });
          }}
        />
      ) : null}
    </div>
  );
}
